import type { ReactNode } from "react";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { useT } from "@transifex/react";
import { useTestCreationContext } from "../../../context/TestCreationContext";
import CancelCreateExerciseModal from "../../../basic/CancelCreateExerciseModal/CancelCreateExerciseModal";
import CloseButton from "../../../basic/closeButton/CloseButton";
import ContentWithHeader from "../../../wrapper/ContentWithHeader/ContentWithHeader";
import { StickyCloseButtonWrapper } from "../testCreationHeader/StyledComponents";

interface VocabTrainingCreationHeaderProps {
    children?: ReactNode;
    hasFullHeightContent?: boolean;
}

const VocabTrainingCreationHeader = (props: VocabTrainingCreationHeaderProps) => {
    const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
    const testCreationContext = useTestCreationContext();
    const history = useHistory();
    const t = useT();

    const t_cancelVocabTrainingText = t(
        "The vocabulary assignment has not been saved yet. Do you really want to discard it?",
        { _tags: "CreateVocabTraining,CancelCreateVocabTraining" }
    );
    const t_cancelText = t("Cancel", { _tags: "CreateVocabTraining,VocabTrainingCreationHeader" });

    const handleLogoClick = () => {
        setIsCancelModalOpen(true);
    };

    const handleConfirmCancel = () => {
        testCreationContext.resetAppStatus();
        history.push("/assistent");
    };

    return (
        <ContentWithHeader
            hasGrayBackground
            hasFullHeightContent={props.hasFullHeightContent}
            onLogoClick={handleLogoClick}
        >
            <StickyCloseButtonWrapper>
                <CloseButton
                    onClick={() => setIsCancelModalOpen(true)}
                    hintText={t_cancelText}
                />
            </StickyCloseButtonWrapper>
            <CancelCreateExerciseModal
                isOpen={isCancelModalOpen}
                closeModalCallback={() => setIsCancelModalOpen(false)}
                continueCallback={handleConfirmCancel}
                text={t_cancelVocabTrainingText}
            />
            {props.children}
        </ContentWithHeader>
    );
};

export default VocabTrainingCreationHeader;
